import { render, staticRenderFns } from "./NieuwsmakerPresentationSlide.vue?vue&type=template&id=680e97c3"
import script from "./NieuwsmakerPresentationSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerPresentationSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680e97c3')) {
      api.createRecord('680e97c3', component.options)
    } else {
      api.reload('680e97c3', component.options)
    }
    module.hot.accept("./NieuwsmakerPresentationSlide.vue?vue&type=template&id=680e97c3", function () {
      api.rerender('680e97c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/NieuwsmakerPresentationSlide.vue"
export default component.exports